import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Header.css";

function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id) => {
    if (location.pathname !== "/") {
      // If not on home, navigate to home and scroll
      navigate("/", { state: { scrollTo: id } });
    } else {
      // If already on home, scroll smoothly
      const section = document.getElementById(id);
      if (section) section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="header">
      {/* Logo */}
      <div className="logo" onClick={() => navigate("/")}>
        Birds Paradise
      </div>

      {/* Navigation buttons */}
      <nav className="nav-buttons">
        <button onClick={() => scrollToSection("home")}>Home</button>
        <button onClick={() => scrollToSection("about")}>About</button>
        <button onClick={() => scrollToSection("services")}>Services</button>
        <button onClick={() => scrollToSection("comments")}>Comments</button>
      </nav>

      {/* Sign In / Login buttons */}
      <div className="auth-buttons">
        <button className="signin-btn" onClick={() => navigate("/signin")}>
          Sign In
        </button>
        <button className="login-btn" onClick={() => navigate("/login")}>
          Login
        </button>
      </div>
    </header>
  );
}

export default Header;




